import React from 'react';
import {auth} from '../firebaseApp';
import AuthUserContext from './AuthUserContext';

const withAuthentication = (Component) => {
    class WithAuthentication extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                authUser: null,
            }
        }

        componentDidMount() {
            this.removeListner = auth.onAuthStateChanged(user => {
                user ? this.setState({authUser: user}) : this.setState({authUser: null});
            })
        }

        componentWillUnmount() {
            this.removeListner();
        }

        render() {
            const { authUser } = this.state;
            return (
                <AuthUserContext.Provider value={authUser}>
                    <Component />
                </AuthUserContext.Provider>
            );
        }
    }

    return WithAuthentication;
}

export default withAuthentication;



// WEBPACK FOOTER //
// ./src/Session/withAuthentication.js